import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthComponent } from './auth.component';

import { LoginComponent } from './login.component';
import { FaqPublicViewComponent } from './faqPublicView.component';
import { EmpadronamientoComponent } from './empadronamiento.component';
import { ExpensaPublicComponent } from './expensaPublic.component';

export const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'faqs-public',
        component: FaqPublicViewComponent,
      },
      {
        path: 'empadronamiento',
        component: EmpadronamientoComponent,
      },
      {
        path: 'expensa-comprobantes',
        component: ExpensaPublicComponent,
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})

export class AuthRoutingModule {
}

export const routedComponents = [
  LoginComponent,
  FaqPublicViewComponent,
  EmpadronamientoComponent,
  ExpensaPublicComponent,
  AuthComponent
];